import { IconButton } from '@sparemin/blockhead';

import styled from 'styled-components';

export const ActionButton = styled(IconButton).attrs({ color: 'tertiary' })`
  width: 13px;
  height: 15px;
`;
